import { ExternalSystemId, useModelGroupsQuery } from '../api/useModelGroupsQuery';

export const useRiskalyzeModelGroup = () => {
  const { data } = useModelGroupsQuery();

  if (!data) {
    return null;
  }

  const { modelPortfoliosGroups } = data;

  return modelPortfoliosGroups.find(
    ({ externalSystem }) => externalSystem === ExternalSystemId.Riskalyze,
  );
};
